var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.verifyshow),expression:"verifyshow"}],staticClass:"pop",attrs:{"id":"verifyPop"}},[_c('div',{staticClass:"content"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.closePop('verifyshow')}}}),_vm._v(" "),_c('div',{staticClass:"huakuai"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }